export default __webpack_public_path__ + "static/Крысиные бега_27-b6d0471cb29196f80ffa845efb6a186b.jpg";